<script lang="ts">
    import { STATUS } from "@/constants/statuses";
    import DesignFeedArrowDownIcon from "@apps/iloom_customization/design_feed/components/icons/DesignFeedArrowDownIcon.svelte";
    import { PaginationMeta } from "@apps/iloom_customization/types/PaginationMeta";
    import { hasNextPage } from "@apps/instagram/utils/paginationUtils";

    import LoadMore from "@components/LoadMore.svelte";

    export let loadMore: (offset: number) => void;
    export let loadMoreStatus: STATUS;
    export let meta: PaginationMeta;

    const handleLoadMore = () => {
        const offset = meta.limit + meta.offset;
        loadMore(offset);
    };

    $: hasNextPage$ = hasNextPage(meta.limit, meta.offset, meta.total);
</script>

{#if hasNextPage$}
    <LoadMore
        ariaLabel="load more posts"
        loading={loadMoreStatus === STATUS.LOADING}
        on:loadMore={handleLoadMore}
        class="gw-df-load-more"
        variant="text"
        size="large"
    >
        More <DesignFeedArrowDownIcon />
    </LoadMore>
{/if}

<style lang="postcss">
    :global(.gw-btn.gw-button.--text.gw-df-load-more) {
        height: 48px;
        padding: 11px 34px 11px 34px;
        border: 1px solid #3c3c3c;
        border-radius: 0;
        transition: all 0.3s ease;
    }
    :global(.gw-btn.gw-button.--text.gw-df-load-more:hover) {
        background-color: #3c3c3c;
        color: #ffffff;
    }
    :global(.gw-btn.gw-button.--text.gw-df-load-more .gw-button__loading) {
        background-color: #fff;
    }

    @media (max-width: 600px) {
        :global(.gw-btn.gw-button.--text.gw-df-load-more) {
            height: 40px;
            padding: 7px 28px 7px 28px;
        }
    }
</style>
